<template>
  <div class="align-center flex ju-sp al-cn">
    <div class="flex al-cn">
      <div class="su-title" :style="{color: color}">
        {{ title }}
      </div>
      <div class="su-description" :style="{color: color}">
        {{ description }}
      </div>
    </div>
    <div class="seeMore" @click="seeMoreClick" v-if="border">查看更多 ></div>
  </div>
</template>
<script>
export default {
  name: 'SuTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    }
  },
  methods:{
    seeMoreClick(){
      this.$emit('seeMoreClick')
    }
  }
}
</script>

<style scoped>

</style>
